import { put } from 'redux-saga/effects';
import ShareAction from '../reducer/shareRedux';

export function* setShareForm(action) {
  const { meta } = action;
  yield put(ShareAction.setShareForm(meta));
}
